import * as React from "react";
import { useArrayField } from "informed";
import { TimePicker } from "../../forms/informedv2/TimePicker";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export const SubjectAlarms = () => {
    const { add, fields } = useArrayField({ field: "Alarms" });

    return (
        <>
            <div className="row">
                <h3 className="col-md-12 text-primary">Alarms</h3>
            </div>
            <div className="row">
                {fields.map(({ field, key, remove }) => (
                    <div key={key} className="form-group col-md-4 col-sm-4 col-xs-12">
                        <TimePicker
                            id={field}
                            field={field}
                            label="Alarm"
                            required={true}
                            placeholderText="HH:mm (24 hour format)"
                            dateFormat="HH:mm"
                            suffix={<FontAwesomeIcon icon={faXmark} className="text-danger" onClick={remove} style={{ cursor: 'pointer' }} />}
                        />
                    </div>)
                )}
            </div>
            <div className="row">
                <div className="col-md-12">
                    <button id="AddAlarm" className="btn btn-primary btn-outline" type="button" onClick={add}>Add Alarm</button>
                </div>
            </div>
        </>
    );
}
